import { fetchWithAuthCheck } from '@/services/fetchWithAuthCheck'
import type { WorkItem } from '@/types/dashboard'
import type { VerificationInfoResponse } from '@/types/dashboard'

export async function getVerificationInfo(): Promise<VerificationInfoResponse> {
  return fetchWithAuthCheck<{ multipleWorkorders: WorkItem[] }>(
    '/verification/getVerificationInfo',
  )
}
